<p-dialog
  *ngIf="viewModel$ | async as viewModel"
  header="Choose Which Details to Keep"
  [modal]="true"
  [style]="{ width: '40vw' }"
  [breakpoints]="{ '992px': '60vw', '510px': '93vw' }"
  [visible]="viewModel.visible"
  [dismissableMask]="true"
  (visibleChange)="store.dispatch(actions.cancelButtonClicked())"
>
  <p *ngIf="viewModel.hasConflicts">
    This customer can only have one company and one billing address. Since these don't match, pick which value should stay after the merge.
  </p>

  <div *ngIf="!viewModel.hasConflicts">
    <p>No conflicting information found between these customers. They're ready to merge.</p>
  </div>

  <div *ngIf="viewModel.company">
    <h6>Company</h6>
    <div class="p-field-radiobutton">
      <p-radioButton
        name="company"
        value="primary"
        [ngModel]="viewModel.selectedCompany"
        (ngModelChange)="store.dispatch(actions.companyOptionSelected({ option: 'primary' }))"
        inputId="company-primary"
      ></p-radioButton>
      <label for="company-primary">{{viewModel.company.primaryValue}}</label>
    </div>
    <div class="p-field-radiobutton">
      <p-radioButton
        name="company"
        value="duplicate"
        [ngModel]="viewModel.selectedCompany"
        (ngModelChange)="store.dispatch(actions.companyOptionSelected({ option: 'duplicate' }))"
        inputId="company-duplicate"
      ></p-radioButton>
      <label for="company-duplicate">{{viewModel.company.duplicateValue}}</label>
    </div>
  </div>

  <div *ngIf="viewModel.billingAddress">
    <h6>Billing Address</h6>
    <div class="p-field-radiobutton">
      <p-radioButton
        name="billingAddress"
        value="primary"
        [ngModel]="viewModel.selectedBillingAddress"
        (ngModelChange)="store.dispatch(actions.billingAddressOptionSelected({ option: 'primary' }))"
        inputId="billing-address-primary"
      ></p-radioButton>
      <label for="billing-address-primary">{{viewModel.billingAddress.primaryValue}}</label>
    </div>
    <div class="p-field-radiobutton">
      <p-radioButton
        name="billingAddress"
        value="duplicate"
        [ngModel]="viewModel.selectedBillingAddress"
        (ngModelChange)="store.dispatch(actions.billingAddressOptionSelected({ option: 'duplicate' }))"
        inputId="billing-address-duplicate"
      ></p-radioButton>
      <label for="billing-address-duplicate">{{viewModel.billingAddress.duplicateValue}}</label>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      (click)="store.dispatch(actions.cancelButtonClicked())"
      icon="pi pi-times"
      label="Cancel"
      class="p-button-outlined"
    ></button>
    <button
      pButton
      (click)="store.dispatch(actions.confirmButtonClicked())"
      icon="pi pi-check"
      label="Confirm Merge"
      class="p-button-success"
    ></button>
  </ng-template>
</p-dialog>
